/* ALVA money helpers.
   The shop-wide EUR format is "€{{amount}}" (dot decimals: what English / Irish shoppers expect).
   - AlvaMoney.fmt(n, digits) formats a number the same way the `money` filter does, for custom scripts.
   - On Spanish pages the server-rendered "€1,234.56" is shown as "€1.234,56" (comma decimals).
   Other currencies (GBP, USD ...) already come out right from Shopify, so they are left alone. */
(function () {
  if (window.AlvaMoney) return;
  var lang = (document.documentElement.lang || 'en').toLowerCase();
  var es = lang.indexOf('es') === 0;
  var CCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';

  function fmt(n, digits) {
    digits = digits === undefined ? 2 : digits;
    try {
      if (CCY === 'EUR') {
        return '€' + n.toLocaleString(es ? 'de-DE' : 'en-GB', { minimumFractionDigits: digits, maximumFractionDigits: digits });
      }
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CCY, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(n);
    } catch (e) {
      return n.toFixed(digits) + ' ' + CCY;
    }
  }
  window.AlvaMoney = { fmt: fmt, currency: CCY, es: es };

  if (!es || CCY !== 'EUR') return;

  var RE = /€\s?(\d{1,3}(?:,\d{3})+|\d+)\.(\d{2})(?!\d)/g;
  function swap(str) {
    return str.replace(RE, function (m, whole, cents) {
      return '€' + whole.replace(/,/g, '.') + ',' + cents;
    });
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, TEMPLATE: 1 };
  function fix(node) {
    if (node.nodeType === 3) {
      var v = node.nodeValue;
      if (v && v.indexOf('€') !== -1) {
        var nv = swap(v);
        if (nv !== v) node.nodeValue = nv;
      }
      return;
    }
    if (node.nodeType !== 1 || SKIP[node.nodeName]) return;
    var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
    var t;
    while ((t = w.nextNode())) {
      if (t.parentNode && SKIP[t.parentNode.nodeName]) continue;
      fix(t);
    }
  }

  function start() {
    fix(document.body);
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        muts.forEach(function (m) {
          if (m.type === 'characterData') fix(m.target);
          else m.addedNodes.forEach(fix);
        });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
